import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=7fd8d3af"
import script from "./Config.vue?vue&type=script&lang=ts"
export * from "./Config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports